import React from "react";
import { MorphingStatusLoader } from "../components/common/MorphingStatusLoader";

export const TestLoader = () => {
  return (
    <div style={{ padding: "40px", display: "flex", flexDirection: "column", gap: "60px", alignItems: "center", background: "var(--surface-0)", minHeight: "100vh" }}>
      <h1>MorphingStatusLoader Showcase</h1>

      <div style={{ display: "flex", gap: "80px", flexWrap: "wrap", justifyContent: "center" }}>
        <div style={{ textAlign: "center" }}>
          <p>Default (PlayPay, #16A34A)</p>
          <MorphingStatusLoader />
        </div>

        <div style={{ textAlign: "center" }}>
          <p>Themed (PlayPay, Green)</p>
          <MorphingStatusLoader label="PlayPay" accentColor="#16A34A" />
        </div>

        <div style={{ textAlign: "center" }}>
          <p>Large</p>
          <MorphingStatusLoader size="24px" label="PlayPay" />
        </div>

        <div style={{ textAlign: "center" }}>
          <p>Very Long Label (Clipped?)</p>
          <MorphingStatusLoader label="Transaction Processing Now" accentColor="#DC2626" />
        </div>
      </div>

      <div style={{ padding: "20px", border: "1px solid var(--border-default)", borderRadius: "12px", background: "var(--surface-1)" }}>
        <h3>Features Tested:</h3>
        <ul>
          <li>✅ Proportional scaling via <code>size</code> prop</li>
          <li>✅ Custom brand labeling via <code>label</code> prop</li>
          <li>✅ Dynamic accent coloring via <code>accentColor</code> prop</li>
          <li>✅ Theme-aware background cutout (using <code>--surface-0</code>)</li>
          <li>✅ Accessibility (aria-labels and roles)</li>
        </ul>
      </div>
    </div>
  );
};
